import { useSelector } from 'react-redux'
import {
  Box,
  LinearProgress,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material'
import { CurrencyCodeEnum, TransactionTypePayment } from '@/enums'

import { PersonalizationEngineType } from '@/state/personalization-engine/models'
import { ApplicationState } from '@/state/root.models'
import { getFormatNumber } from '@/utils'

interface Props {
  row: PersonalizationEngineType
}

export const FavoriteGamesTableRowComponent = ({ row }: Props) => {
  const { filters } = useSelector(
    ({ personalizationEngine }: ApplicationState) => personalizationEngine,
  )

  return (
    <TableRow hover>
      <TableCell>{row.position}</TableCell>
      <TableCell>{row.name}</TableCell>
      <TableCell>{row.game_id}</TableCell>
      {!filters.transactionTypePayment && (
        <TableCell>
          {getFormatNumber(Number(row.amount), CurrencyCodeEnum.USD)}
        </TableCell>
      )}
      {filters.transactionTypePayment?.toString() ===
        `${TransactionTypePayment.REAL_MONEY}` && (
        <TableCell>
          {getFormatNumber(Number(row.amount_real_money), CurrencyCodeEnum.USD)}
        </TableCell>
      )}
      {filters.transactionTypePayment?.toString() ===
        `${TransactionTypePayment.BONUS_MONEY}` && (
        <TableCell>
          {getFormatNumber(
            Number(row.amount_bonus_money),
            CurrencyCodeEnum.USD,
          )}
        </TableCell>
      )}
      {!filters.transactionTypePayment && (
        <TableCell>
          <Box sx={{ display: 'flex', alignItems: 'center', pr: 2 }}>
            <Box sx={{ width: '100%', mr: 1 }}>
              <LinearProgress
                variant="determinate"
                value={Number(parseFloat(row.percentage).toFixed(2))}
                sx={{ borderRadius: '8px', height: '6px' }}
              />
            </Box>
            <Box sx={{ minWidth: 35 }}>
              <Typography variant="body2">{`${parseFloat(
                row.percentage,
              ).toFixed(2)}%`}</Typography>
            </Box>
          </Box>
        </TableCell>
      )}
      {filters.transactionTypePayment?.toString() ===
        `${TransactionTypePayment.REAL_MONEY}` && (
        <TableCell>
          <Box sx={{ display: 'flex', alignItems: 'center', pr: 2 }}>
            <Box sx={{ width: '100%', mr: 1 }}>
              <LinearProgress
                variant="determinate"
                value={Number(parseFloat(row.percentage_real_money).toFixed(2))}
                sx={{ borderRadius: '8px', height: '6px' }}
              />
            </Box>
            <Box sx={{ minWidth: 35 }}>
              <Typography variant="body2">{`${parseFloat(
                row.percentage_real_money,
              ).toFixed(2)}%`}</Typography>
            </Box>
          </Box>
        </TableCell>
      )}
      {filters.transactionTypePayment?.toString() ===
        `${TransactionTypePayment.BONUS_MONEY}` && (
        <TableCell>
          <Box sx={{ display: 'flex', alignItems: 'center', pr: 2 }}>
            <Box sx={{ width: '100%', mr: 1 }}>
              <LinearProgress
                variant="determinate"
                value={Number(
                  parseFloat(row.percentage_bonus_money).toFixed(2),
                )}
                sx={{ borderRadius: '8px', height: '6px' }}
              />
            </Box>
            <Box sx={{ minWidth: 35 }}>
              <Typography variant="body2">{`${parseFloat(
                row.percentage_bonus_money,
              ).toFixed(2)}%`}</Typography>
            </Box>
          </Box>
        </TableCell>
      )}
    </TableRow>
  )
}
